import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import productsData from "../data/products.json";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const MarketPlace = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const leftToRightVariant = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const rightToLeftVariant = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const navigate = useNavigate();

  // Check if the current screen is mobile
  const isMobile = window.innerWidth <= 768; // Adjust the breakpoint as needed

  return (
    <div className="container mt-5">
      <div className="text-center lg-mb-5">
        <h1 className="market-head fw-bold">Your Security is Our Priority</h1>
      </div>

      {/* Products Grid */}
      {Array.isArray(productsData.products) &&
      productsData.products.length > 0 ? (
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          {productsData.products.map((product, index) => (
            <div key={index} className="col text-center">
              {/* Heading Section */}
              <h3
                className="market-heading mb-4"
                style={{
                  fontWeight: "bold",
                  marginBottom: "1rem",
                  whiteSpace: "none",
                }}
              ></h3>

              {/* Image Section */}
              <motion.div
                className="image-box"
                initial="hidden"
                whileInView="visible"
                variants={
                  index % 2 === 0 ? leftToRightVariant : rightToLeftVariant
                }
                viewport={{ once: false }}
              >
                <img
                  src={require(`../assets${product.marketimg}`)}
                  onClick={() => {
                    const formattedCategoryName = product.categoryName.replace(
                      /\s+/g,
                      "-"
                    ).toLowerCase() // Replace spaces with hyphens
                    navigate(`${basePath}market-place/${formattedCategoryName}`);
                    scrollToTop();
                  }}
                  alt={product.categoryName}
                  className="img-fluid rounded align-items-center market-place-img"
                  style={{
                    width: "80%",
                    objectFit: "cover",
                    marginBottom: "1rem",
                    cursor: "pointer",
                  }}
                />
              </motion.div>

              {/* Button Section */}
              <button
                className="btn btn-danger lg-mb-5"
                onClick={() => {
                  const formattedCategoryName = product.categoryName.replace(
                    /\s+/g,
                    "-"
                  ).toLowerCase() // Replace spaces with hyphens
                  navigate(`${basePath}market-place/${formattedCategoryName}`);
                  scrollToTop();
                }}
              >
                Explore
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div>No products available.</div>
      )}
    </div>
  );
};

export default MarketPlace;
